module.exports = __webpack_public_path__ + "static/img/5.fd729c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/5.png
// module id = pyTI
// module chunks = 0